import { Component } from '@angular/core';
import { InspectionDetailComponent } from '../../../inspections/components/detail.component';

@Component({
    selector: 'inspection-model-detail',
    templateUrl: './inspection-model-detail.component.html',
    standalone: false
})
export class InspectionModelDetailComponent extends InspectionDetailComponent {}
